<!--
    !! WARNING !!
    Seems to work on the user form of changing roles, but be aware, may not work correctly


     <GenericTreeviewSelect
       :props="my_attrs_dictionary"
     />

     Public propertys:
       value → Gives the field's serializable value

     Accepted props:
     - items → now ( [[value, text], [1, 'User 1']] ) , correct ([{value, text, children, ...} ], [{1, 'User 1', [{...}], ...}])
     - value
     - label
     - placeholder
     - multiple (Not now, possible )
-->

<template>
  <v-menu
    :value="menu"
    offset-y
    :disabled="!!props.readonly"
    open-on-focus
    :close-on-click="false"
    :close-on-content-click="false"
  >
  <!--
        v-on="on"
  -->
    <template v-slot:activator="{ on, attrs }">
      <v-autocomplete
        v-bind="attrs"
        :id="'qmkey-form-treeview-'+props.id"
        :value="value"
        :label="props.label"
        :class="[
          props.class || props.readonly ? 'qmkey-form-input-readonly' : 'qmkey-form-input',
          { required: props.required },
        ]"
        :rules="rules"
        outlined
        dense
        background-color="#f2f2f2"
        :search-input="search"
        @update:search-input="search_text"
        :disabled="!!props.disabled"
        :readonly="!!props.readonly"
        :placeholder="props.placeholder"
        :items="props.items || []"
        :small-chips="props.chips"
        deletable-chips
        :multiple="props.multiple"
        :menu-props="{maxHeight: 0}"
        @focus="open_menu"
        @input="update"
      >
        <template v-slot:activator><v-btn></v-btn></template>
        <template v-slot:append>
          <v-icon v-if="!props.readonly && !props.disabled && (value && value.length > 0)" @click="clear">
            mdi-close
          </v-icon>
          <v-icon v-if="!props.readonly && !props.disabled" @click="toggle_menu">
            mdi-menu-down
          </v-icon>
        </template>
      </v-autocomplete  >
    </template>
    <div
      class="qmkey-menu-content-tree"
    >
    <v-treeview
        ref="directory-tree"
        :value="value"
        :active="value"
        dense
        :multiple-active="props.multiple"
        :search="search"
        :items="items_tree"
        return-object
        selection-type="independent"
      > 
        <template v-slot:prepend="{item, selected, active}">
          <v-btn
            v-if="!item.is_group"
            icon
            @click.stop="manage_active(item)"
            :class="['qmkey-clickable-tree-item',value.includes(item.id) ? 'accent--text' : '']"
          >
            <v-icon medium class="qmkey-clickable-tree-item"> {{ (value.includes(item.id) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline') }}</v-icon>
          </v-btn>
        </template>
        <template v-slot:label="{item}">
          <span 
            style="font-size: small;"
            :class="['qmkey-clickable-tree-item', item.is_group ? 'font-weight-bold block-piner-events' : '']"
            @click.stop="manage_active(item)"
          >
            {{ item.name }}
          </span>
        </template>
      </v-treeview>
    </div>
  </v-menu>
</template>

<style lang="scss">
  @import '@/sass/modalform.scss';
  .qmkey-clickable-tree-item {
    cursor: pointer;
  }
  .qmkey-menu-content-tree {
    background-color: white;
    max-height: 300px;
    overflow-y: auto;
  }
</style>

<script>
import QTree from '@/utils/QTree'
export default {
  name: 'GenericTreeviewSelect',

  components:{
  },

  props: ['props'],

  data: () => ({
    valid: true,
    search: null,
    menu: false,
    is_writing: false,
  }),

  computed: {
    current_tree() {
      let items = this.props.items;

      if (this.props.group_id && this.props.group_name) {
      const group_childrens = Object.groupBy(items,(item)=>item[this.props.group_id])
      const group_entries = (Object.entries(group_childrens) || [])
                              .map(([id,children]) => ({
                                'id': id, 
                                'name': (children[0] || {})[this.props.group_name] || this.props.group_id , 
                                'is_group': true,
                                'children': children}))
        items = group_entries;
      }

      return new QTree(items || []);
    },
    
    items_tree() {
      return Object.values(this.current_tree.get_array_tree()).sort((p1, p2) => p1.name.localeCompare(p2.name));
    },
    
    value() {
      let r = this.props.value || []
      if (
        this.props.value &&
        this.props.multiple &&
        this.props.value.length < 1
      ) {
        r = []
      }
      return r
    },

    autocomplete_value() {
      return this.value;
    },

    rules() {
      // TODO: Multilang: Change hardcoded string
      return [(value) => !!value || !this.props.required || this.$vuetify.lang.translator('required_field')]
    },
  },

  mounted() {
    this.start_listeners();
  },

  beforeDestroy() {
    this.remove_listeners();
  },


  methods: {

    open_menu() {
      this.menu=true;
      this.do_not_close();
    },

    close_menu() {
      this.menu=false;
    },

    toggle_menu() {
      if (this.menu) {
        this.close_menu();
      } else {
        this.open_menu();
      }
    },

    do_not_close() {
      //Reset the search text for the autocomplete

      const save_text = this.search;
      this.search = null;
      this.$nextTick(()=>{
      document.getElementById('qmkey-form-treeview-'+this.props.id).focus()
        this.search = save_text;
      })
    },

    validate_blur(element) {
      // Validate the click is outside the autocomplete and the menu content (treeview)
      const autocomplete_id = 'qmkey-form-treeview'
      const valid_class_name = ['qmkey-clickable-tree-item','v-treeview-node__label','v-treeview-node__toggle','v-treeview-node__root','v-treeview-node__content']

      const target_id = element.target.id;
      const element_classes = element.target.classList;
      const parent_classes = element.target.parentElement.classList;

      let res = false;
      const is_valid = valid_class_name.map(it => element_classes.contains(it) || parent_classes.contains(it)).reduce((res,current) => res || current, res,)

      if (is_valid || (target_id && target_id.includes(autocomplete_id))) {
        this.do_not_close();
      } else {
        this.close_menu();
      }
    },

    start_listeners() {
      document.addEventListener('mousedown',this.validate_blur);
    },

    remove_listeners() {
      document.removeEventListener('mousedown',this.validate_blur);

    },

    validate() {
      // TODO: Show error message
      return this.valid;
    },

    clear() {
      this.clear_search();
      this.update();
    },

    error_state(ok) {
      this.valid = ok;
    },

    clear_search() {
      this.search = null;
    },

    search_text(text) {
      this.search = text;
    },

    manage_active(item) {
      let res = item || [];
      if (!!item && this.props.multiple) {
        const index = this.value.indexOf(item.id )
        if (!this.value || index < 0) {
          res = [...this.value,item.id];
        } else {
          res = [...this.value];
          res.splice(index,1);
        }
      } else if(!!item){
        res = [item.id];
      }
      this.update(res);
    },

    update(value) {
      this.$emit('update',value);
    },
  },
  watch: {
    menu() {
      if (!this.menu) {
        this.clear_search();
      }
    },
  }
}
</script>

